import { take } from 'rxjs';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { SellerModel } from 'libs/shared/src/lib/models/sellers/sellers.model';
import { CategoryModel } from 'libs/shared/src/lib/models/categories/categories.model';
import { StateManagementService } from 'libs/shared/src/lib/state-management/state-management.service';
import { CategoryService } from '@gen/shared';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss'],
})
export class CategoriesComponent implements OnInit {
  public seller: SellerModel = new SellerModel();
  public pointId: string;

  public productsCategoryList: Array<CategoryModel> = [];
  public productsCustomCategoryList: Array<CategoryModel> = [];

  public loading: boolean = true;

  constructor(
    private $categories: CategoryService,
    private $notification: StateManagementService,
    private router: Router
  ) {}

  public ngOnInit(): void {
    this.getNotifications();
  }

  public getNotifications(): void {
    this.$notification.sellers.subscribe((seller) => {
      if (seller) {
        this.seller = seller;
      }
    });

    this.$notification.categories.subscribe((categories) => {
      if (categories) {
        this.getCategoryList(categories);
      } else {
        this.$categories.getAndSetCategoriesAll();
      }
    });

    this.$notification.routeParams.subscribe((ids) => {
      if (ids) {
        this.pointId = ids.pointId;
      }
    });
  }

  public getCategoryList(categories): void {
    this.$categories
      .getCategoryList(this.seller.id)
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          if (res?.data?.listItemCategories) {
            this.productsCategoryList = res.data.listItemCategories;
            this.productsCategoryList = this.productsCategoryList.map((categorie) => {
              const obj = {
                label: categorie.name,
                value: categorie.id,
                isLeaf: true,
                children: [],
              };
              return obj;
            });
          }

          let options: any = this.$categories.setCategoriesCascader(categories);
          options = options.concat(this.productsCategoryList);
          this.productsCategoryList = options.filter((res) => res['isParent']);
          this.productsCustomCategoryList = options.filter((res) => !res['isParent']);

          this.loading = false;
        },
        error: (error) => {
          throw new Error(error);
        },
      });
  }

  public onSelectCategory(category: any, type: string): void {
    if (category) {
      if (type === 'selected') {
        category.sellerId = this.seller.id;
        this.router.navigate(['/internal/products'], { queryParams: { categoryId: category.value } });
        this.$notification.setChangedCategory(category);
        this.$notification.setIsCategory(true);
      }
    }
  }
}
